import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '@react/survey-excerpt/components/App'
import modal from '@scripts/components/modal'

const rootNode = document.getElementById('survey-excerpt-app')

const root = createRoot(rootNode)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

modal.init()
